const { ControllerStyles } = require('../../../../components/ControllerStyles');
const { Knob } = require('../../../../components/Knob');

const StereoWidth = ({ settings, onUpdate }) => (
   <div>
      <svg width={500} height={500}>
         <ControllerStyles>
            <Knob
               x={50}
               y={50}
               diameter={50}
               value={settings.width}
               onChange={(value) => onUpdate({ width: { $set: value } })}
            />
         </ControllerStyles>
      </svg>
   </div>
);

export { StereoWidth };
